import React from 'react'
import AuthPage from '../../../Auth/AuthPage'

// Admin entry point — the shared screen lives in Components/Auth/AuthPage.
const AdminLogin = () => <AuthPage role="admin" />

export default AdminLogin
